"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchStatusIcons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var CircularProgress_1 = require("../../atoms/CircularProgress/CircularProgress");
var Icon_1 = require("../../atoms/Icon/Icon");
var Tooltip_1 = require("../../atoms/Tooltip/Tooltip");
var SearchStatusIcons_style_1 = __importDefault(require("./SearchStatusIcons.style"));
/**
 * SearchStatusIcons molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-searchstatusicons--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/SearchStatusIcons Source}
 */
var SearchStatusIcons = function (_a) {
    var className = _a.className, searchInput = _a.searchInput, loading = _a.loading, onClearInput = _a.onClearInput, searchError = _a.searchError, disabled = _a.disabled;
    var classes = (0, SearchStatusIcons_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, className) }, { children: [renderStatusInfo(), renderClearIcon()] })));
    function renderStatusInfo() {
        if (loading && (searchInput || disabled)) {
            return (0, jsx_runtime_1.jsx)(CircularProgress_1.CircularProgress, { className: classes.statusInfoSpacing, size: 13 });
        }
        if (searchInput && searchError) {
            return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: searchError }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.information, size: 16, color: theme_1.default.colors.error, className: (0, classnames_1.default)(classes.errorIcon, classes.statusInfoSpacing) }) })));
        }
        return null;
    }
    function renderClearIcon() {
        if (searchInput) {
            return ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.close, color: theme_1.default.colors.dark, className: (0, classnames_1.default)(classes.clearIcon, 'hoverable'), onClick: onClearInput, hoverVariant: 'default' }));
        }
        return null;
    }
};
exports.SearchStatusIcons = SearchStatusIcons;
